import React, { useState, useEffect } from 'react';
import { ButtonGroup, Button, Grid } from "@material-ui/core";
import { useVideo } from '../../api/VideoProvider';
import { Add, Remove, Send } from '@material-ui/icons';
import { pRecordTime, pStatus } from '../../utils/parameters';
import useMediaQuery from '@mui/material/useMediaQuery';
import { pVisualControl } from '../../utils/parameters';
import { useTranslation } from "react-i18next";

export function RecordingButtons(props) {
    const { handleSend, setSelectedSign, sign, switchGalibo, visualControlAction, customTimer } = props;
    const { t } = useTranslation("global")

    const [timer, setTimer] = useState(pRecordTime.default);
    const [timerMax, setTimerMax] = useState(pRecordTime.max);
    const [timerMin, setTimerMin] = useState(pRecordTime.min);
    const [timerStep, setTimerStep] = useState(pRecordTime.step);
    const [recordText, setRecordText] = useState(t("sRecordComponent.recordButton"));
    const { recTime, setRecTime, setFaceStatus, faceStatus } = useVideo();

    /* MOB - Nav responsiveness*/
    const queryChecks = {
        textWidthLimit: useMediaQuery('(max-width:260px)'),
    }

    useEffect(() => {
        //autoAction_label == "Grabar"
        // console.log('visualControlAction option: '+visualControlAction)

        switch (visualControlAction) {
            case pVisualControl.Btn_Grabar.id_action:
                startVideo()
                break;
            case pVisualControl.Btn_Repetir.id_action:
                repeatVideo()
                break;
            case pVisualControl.Btn_Enviar.id_action:
                handleSend()
                break;
            default:
                break;
        }
    }, [visualControlAction])

    useEffect(() => {
        // console.log("🚀 ~ file: RecordingButtons.js:48 ~ useEffect ~ customTimer:", customTimer)
        if (customTimer!==undefined){
            setTimer(customTimer['timer'])
            setTimerMax(customTimer['max'])
            setTimerMin(customTimer['min'])
            setTimerStep(customTimer['step'])
        }
    }, [customTimer])

    // useEffect(() => {
    //     console.log("🚀 ~ file: RecordingButtons.js:54 ~ RecordingButtons ~ timer:", timer)    
    //     console.log("🚀 ~ file: RecordingButtons.js:54 ~ RecordingButtons ~ timerMax:", timerMax)    
    //     console.log("🚀 ~ file: RecordingButtons.js:54 ~ RecordingButtons ~ timerMin:", timerMin)    
    //     console.log("🚀 ~ file: RecordingButtons.js:54 ~ RecordingButtons ~ timerStep:", timerStep)    
    // }, [timer])
    

    /* Toggle between 'Record' and 'Cancel' */
    function startVideo() {
        // console.log('start record')
        if (faceStatus === pStatus.init) {
            setRecTime(timer);
            // console.log(pStatus.countdown);
            // switchGalibo ? setFaceStatus(pStatus.runTf) : setFaceStatus(pStatus.countdown);
            setFaceStatus(pStatus.countdown);

            /* 
                MOB - I am commenting the following line because when the text changes from "GRABAR" to "CANCELAR", the
                button disables itself, so a user can't actually cancel the recording. This way at least there is no confusion.
            */
            setVideoRefPlayState(false)

        }
        else {
            setFaceStatus(pStatus.init)
            setRecordText(t("sRecordComponent.recordButton"))
            setVideoRefPlayState(true)
        }
    }

    /* Handle repeat button */
    function repeatVideo() {
        setRecordText(t("sRecordComponent.recordButton"))
        setFaceStatus(pStatus.init)
        setVideoRefPlayState(true)
    }

    function setVideoRefPlayState(value){
        try{
            setSelectedSign(value)
        }catch(e){        
        }
    }

    /* Manage +/- buttons */
    function increaseTimer() {
        timer >= timerMax ? setTimer(timerMax) : setTimer(timer + timerStep);
    }

    function decreaseTimer() {
        timer <= timerMin ? setTimer(timerMin) : setTimer(timer - timerStep);
    }


    // function increaseTimer() {
    //     timer >= pRecordTime.max ? setTimer(pRecordTime.max) : setTimer(timer + pRecordTime.step);
    // }

    // function decreaseTimer() {
    //     timer <= pRecordTime.min ? setTimer(pRecordTime.min) : setTimer(timer - pRecordTime.step);
    // }

    // useEffect(() => {
    //     setTimer(recTime)
    // }, [recTime])

    /* MOB - Since the actual cancel button disables itself when recording, I'll also comment this section, as it
    seems to just change the button text back.*/
    /*
    // Function.prototype() doesnt do anything (= NOP) 
    useEffect(() => {
        faceStatus === pStatus.rep ? setRecordText('Grabar') : Function.prototype();
    }, [faceStatus])
    */

    /* Unable/Disable buttons */
    function disableStart() {

        if (sign===''){
            return true
        }
        if (faceStatus <= pStatus.faceDetected && faceStatus !== pStatus.error) {
            return false
        }
        return true
    }

    function disableRepeat() {
        if (faceStatus === pStatus.rep && faceStatus !== pStatus.error) {
            return false
        }
        return true
    }
    
    return (
        <Grid container className='sig_Home_ButtonsContainerInner'>            
            {props.children}
            <Grid item className='sig_Home_RecordingButtons_TimeControl'>
                <ButtonGroup data-tour='tourCam_3' className='sig_Home_TimerButtons' variant="contained" color="primary" disabled={disableStart()}>
                    <Button startIcon={<Remove />} onClick={decreaseTimer}></Button>
                    <Button data-tour='tourCam_6' >{timer} {queryChecks.textWidthLimit ? <> {t("sRecordComponent.sec")} </> : <> {t("sRecordComponent.seconds")} </> }</Button>
                    <Button startIcon={<Add />} onClick={increaseTimer}></Button>
                </ButtonGroup>
            </Grid>
            <Grid item className='sig_Home_RecordingButtons_RecordRepeat'>
                <ButtonGroup className='sig_Home_RecordingButtons' variant="contained" color="primary">
                    <Button data-tour='tourCam_5' onClick={startVideo} disabled={disableStart()}>{recordText}</Button>
                    <Button data-tour="tourCam_7b" onClick={repeatVideo} disabled={disableRepeat()}> {t("sRecordComponent.repeatButton")} </Button>
                </ButtonGroup>
            </Grid>
            <Grid item className='sig_Home_RecordingButtons_Send'>
                <Button data-tour='tourCam_8' className='sig_Home_SendButton' variant="contained" color="primary" endIcon={<Send />}
                    disabled={disableRepeat()} onClick={handleSend}>
                    {t("sRecordComponent.sendButton")}
                </Button>
            </Grid>
        </Grid >
    )
}